/* ==========================================================================
   Lumen — section-fbt.js
   <fbt-bundle> — "frequently bought together": a running total of the checked
   items + one add-all-to-cart request (theme.cart.add with an array).
   Self-contained (works as a standalone section, outside <product-info>).
   ========================================================================== */
(function () {
  'use strict';
  if (!('customElements' in window) || customElements.get('fbt-bundle')) return;

  function formatMoney(cents) {
    var fmt = (window.theme && theme.settings && theme.settings.moneyFormat) || '${{amount}}';
    var n = cents / 100;
    var str = /amount_no_decimals/.test(fmt) ? String(Math.round(n)) : n.toFixed(2);
    var parts = str.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return fmt.replace(/\{\{\s*amount[^}]*\}\}/, parts.join('.'));
  }

  customElements.define('fbt-bundle', class extends HTMLElement {
    connectedCallback() {
      if (this._init) return;
      this._init = true;
      var bundle = this;
      var totalEl = bundle.querySelector('[data-bundle-total]');
      var addBtn = bundle.querySelector('[data-bundle-add]');

      function recompute() {
        var total = 0, any = false;
        bundle.querySelectorAll('[data-bundle-item]').forEach(function (cb) {
          if (cb.checked) { total += parseInt(cb.getAttribute('data-price'), 10) || 0; any = true; }
        });
        if (totalEl) totalEl.textContent = formatMoney(total);
        if (addBtn) addBtn.disabled = !any;
      }

      bundle.addEventListener('change', function (e) {
        if (e.target && e.target.hasAttribute && e.target.hasAttribute('data-bundle-item')) recompute();
      });

      if (addBtn) {
        addBtn.addEventListener('click', function () {
          var items = [];
          bundle.querySelectorAll('[data-bundle-item]:checked').forEach(function (cb) {
            var id = parseInt(cb.getAttribute('data-variant-id'), 10);
            if (id) items.push({ id: id, quantity: 1 });
          });
          if (!items.length || !(window.theme && theme.cart && theme.cart.add)) return;
          addBtn.classList.add('is-loading');
          theme.cart.add(items)
            .then(function () { if (theme.toast) theme.toast((theme.strings && theme.strings.addedToCart) || 'Added to cart'); })
            .catch(function (err) { if (theme.toast) theme.toast(err.message || 'Could not add to cart'); })
            .finally(function () { addBtn.classList.remove('is-loading'); });
        });
      }

      recompute();
    }
  });
})();
